export const ActionType = {
  home: {
    name: {
      key: 'home',
      name: '首页'
    },
    applyProject: {
      key: 'home_applyProject',
      name: '点击“申请项目”'
    },
    try: {
      key: 'home_try',
      name: '点击“立即试用”'
    },
    enter: {
      key: 'home_enter',
      name: '点击“立即进入”'
    }
  },
  onlinePS: {
    name: {
      key: 'ps_online',
      name: '在线PS'
    },
    psSavePsd: {
      key: 'ps_savePsd',
      name: '保存为PSD'
    }
  },
  project: {
    switch: {
      key: 'project_switch',
      name: '切换项目'
    }
  },
  publicTemplate: {
    name: {
      key: 'public_template',
      name: '模板广场'
    }
  },
  template: {
    name: {
      key: 'template',
      name: '模板库'
    },
    edit: {
      key: 'template_use',
      name: '点击“编辑”'
    },
    preview: {
      key: 'template_preview',
      name: '点击“预览”'
    },
    useTemplate: {
      key: 'template_useTemplate',
      name: '点击“使用模板”'
    },
    goToEditor: {
      key: 'template_goToEditor',
      name: '点击模板进入编辑'
    },
    switch: {
      key: 'template_switch',
      name: '点击左右切换查看'
    },
    save: {
      key: 'template_save',
      name: '点击“保存模板”'
    },
    tagSearch: {
      key: 'template_tagSearch',
      name: '分类搜索'
    },
    sizeSearch: {
      key: 'template_sizeSearch',
      name: '尺寸搜索'
    },
    addTag: {
      key: 'template_addTag',
      name: '添加分类'
    },
    editTag: {
      key: 'template_editTag',
      name: '修改分类'
    },
    download: {
      key: 'template_download',
      name: '模板下载'
    }
  },
  templateGroup: {
    edit: {
      key: 'multiTemplate_edit',
      name: '点击“编辑”图文'
    },
    editor: {
      name: {
        key: 'editMulti',
        name: '图文模板编辑页'
      },
      preview: {
        key: 'editMulti_preview',
        name: '预览'
      },
      save: {
        key: 'editMulti_save',
        name: '点击“保存”'
      },
      export_png: {
        key: 'exportMulti_exportPNG',
        name: '点击“导出”png'
      },
      export_jpg: {
        key: 'exportMulti_exportJPG',
        name: '点击“导出”jpg'
      },
      export_ppt: {
        key: 'exportMulti_exportPPT',
        name: '点击导出PPT'
      },
      export_multiple: {
        key: 'exportMulti_exportSlice',
        name: '点击导出多图'
      },
      copy: {
        key: 'editMulti_cpCanvas',
        name: '点击“复制”画布'
      },
      del: {
        key: 'editMulti_delCanvas',
        name: '点击“删除”画布'
      },
      add: {
        key: 'editMulti_addCanvas',
        name: '点击“添加画布”'
      },
      returnHome: {
        key: 'editMulti_home',
        name: '点击“首页”'
      },
      drag: {
        key: 'editMulti_moveCanvas',
        name: '拖拽画布'
      },
      selection: {
        key: 'editMulti_clickCanvas',
        name: '点击画布'
      },
      reset: {
        key: 'editMulti_reset',
        name: '恢复'
      },
      rollback: {
        key: 'editMulti_rollback',
        name: '撤销'
      },
      plus: {
        key: 'editMulti_plus',
        name: '点击“+”'
      },
      minus: {
        key: 'editMulti_minus',
        name: '点击“-”'
      },
      toggleHide: {
        key: 'editMulti_hiddenMaterial',
        name: '点击“显示/隐藏”'
      },
      updateModule: {
        key: 'editMulti_editThisPlace',
        name: '点击“点击此处修改模块内容”'
      },
      cutImg: {
        key: 'editMulti_cutoutMaterial',
        name: '点击“剪裁”素材'
      },
      replaceModule: {
        key: 'editMulti_editChangePSD',
        name: '更换方案'
      }
    },
    works: {
      editWorks: {
        key: 'multiWorks_edit',
        name: '点击“编辑”图文'
      }
    }
  },
  works: {
    myWorksName: {
      key: 'work_myWork',
      name: '我的作品'
    },
    teamWorksName: {
      key: 'work_teamWork',
      name: '团队作品'
    },
    edit: {
      key: 'works_edit',
      name: '点击“编辑”'
    },
    export: {
      key: 'works_export',
      name: '点击“导出”'
    },
    batchExport: {
      key: 'works_batchExport',
      name: '点击“批量导出”'
    },
    preview: {
      key: 'works_preview',
      name: '点击“预览”'
    },
    copyWorks: {
      key: 'works_copyWorks',
      name: '点击“复制作品”'
    },
    shareWorks: {
      key: 'works_shareWorks',
      name: '点击“分享作品”'
    },
    copyLink: {
      key: 'works_copyLink',
      name: '点击“复制链接”'
    },
    delWorks: {
      key: 'works_delWorks',
      name: '点击“删除”'
    },
    batchDelWorks: {
      key: 'works_batchDelWorks',
      name: '点击“批量删除”'
    },
    selectAll: {
      key: 'works_selectAll',
      name: '点击“全选”'
    },
    search: {
      key: 'works_search',
      name: '点击“搜索”'
    },
    switch: {
      key: 'works_switch',
      name: '点击“左右切换”'
    },
    check: {
      key: 'works_check',
      name: '点击“勾选作品”'
    },
    goToEditor: {
      key: 'works_goToEditor',
      name: '点击作品进入编辑'
    },
    editName: {
      key: 'works_editName',
      name: '编辑名称'
    },
    sizeSearch: {
      key: 'works_sizeSearch',
      name: '尺寸搜索'
    },
    timeSearch: {
      key: 'works_timeSearch',
      name: '更新时间搜索'
    },
    worksNameSearch: {
      key: 'works_worksNameSearch',
      name: '作品名称搜索'
    }
  },
  worksPreview: {
    myWorksName: {
      key: 'preview_myWorks',
      name: '我的作品-预览'
    },
    teamWorksName: {
      key: 'preview_teamWorks',
      name: '团队作品-预览'
    },
    export: {
      key: 'preview_export',
      name: '点击“导出”'
    },
    goToEditor: {
      key: 'preview_goToEditor',
      name: '点击“编辑”'
    },
    switch: {
      key: 'preview_switch',
      name: '点击左右切换查看'
    }
  },
  material: {
    imgName: {
      key: 'material_img',
      name: '图片素材'
    },
    bgName: {
      key: 'material_bg',
      name: '背景素材'
    },
    del: {
      key: 'material_del',
      name: '点击“删除”'
    },
    batchDel: {
      key: 'material_batchDel',
      name: '点击“批量删除”'
    },
    upload: {
      key: 'material_upload',
      name: '点击“上传”'
    },
    selectAll: {
      key: 'material_selectAll',
      name: '点击“全选”'
    },
    check: {
      key: 'material_check',
      name: '勾选素材'
    },
    search: {
      key: 'material_search',
      name: '点击“搜索”'
    },
    timeSearch: {
      key: 'material_timeSearch',
      name: '更新时间搜索'
    },
    nameSearch: {
      key: 'material_nameSearch',
      name: '素材名称搜索'
    },
    switch: {
      key: 'material_switch',
      name: '点击左右切换查看'
    },
    tagSearch: {
      key: 'material_tagSearch',
      name: '素材标签搜索'
    },
    sizeSearch: {
      key: 'material_sizeSearch',
      name: '素材尺寸搜索'
    },
    groupSearch: {
      key: 'material_groupSearch',
      name: '联动组搜索'
    },
    addTag: {
      key: 'material_batchAddTag',
      name: '点击“添加标签”'
    },
    uploadBgGroup: {
      key: 'material_uploadBgGroup',
      name: '点击“上传背景组”'
    },
    uploadBg: {
      key: 'material_uploadBg',
      name: '点击“上传背景图”'
    },
    group: {
      key: 'material_group',
      name: '分组'
    },
    batchGroup: {
      key: 'material_batchGroup',
      name: '批量分组'
    }
  },
  themeColor: {
    name: {
      key: 'material_bgColor',
      name: '背景颜色'
    },
    addColor: {
      key: 'material_addColor',
      name: '新增背景颜色'
    },
    editColor: {
      key: 'material_editColor',
      name: '编辑背景颜色'
    },
    delColor: {
      key: 'material_delColor',
      name: '删除背景颜色'
    },
    batchDelColor: {
      key: 'material_batchDelColor',
      name: '批量删除背景颜色'
    }
  },
  materialGroup: {
    page: {
      key: 'material_psd_group',
      name: '方案组'
    },
    del: {
      key: 'material_psd_group_del',
      name: '点击“删除”'
    },
    batchDel: {
      key: 'material_psd_group_batchDel',
      name: '点击“批量删除”'
    },
    upload: {
      key: 'material_psd_group_upload',
      name: '点击“上传”'
    },
    selectAll: {
      key: 'material_psd_group_selectAll',
      name: '点击“全选”'
    },
    check: {
      key: 'material_psd_group_check',
      name: '勾选素材'
    },
    search: {
      key: 'material_psd_group_search',
      name: '点击“搜索”'
    }
  },
  editor: {
    name: {
      key: 'edit',
      name: '编辑页'
    },
    materialTab: {
      key: 'edit_materialTab',
      name: '点击“素材（导航）”'
    },
    bgTab: {
      key: 'edit_bgTab',
      name: '点击“素材（导航）”'
    },
    templateTab: {
      key: 'edit_templateTab',
      name: '点击“页面（导航）”'
    },
    copyTemplate: {
      key: 'edit_copyTemplate',
      name: '点击“复制模板”'
    },
    delCopyTemplate: {
      key: 'edit_delCopyTemplate',
      name: '删除复制模板'
    },
    rollback: {
      key: 'edit_rollback',
      name: '点击“撤消”'
    },
    rollnext: {
      key: 'edit_rollnext',
      name: '点击“前进”'
    },
    reset: {
      key: 'edit_reset',
      name: '点击“恢复”'
    },
    preview: {
      key: 'edit_preview',
      name: '点击“手机预览”'
    },
    save: {
      key: 'edit_save',
      name: '点击“保存作品”'
    },
    export: {
      key: 'edit_export',
      name: '点击“导出”'
    },
    oneAndOne: {
      key: 'edit_oneAndOne',
      name: '点击“1:1”'
    },
    resetDefault: {
      key: 'edit_resetDefault',
      name: '点击“恢复至默认”'
    },
    plus: {
      key: 'edit_plus',
      name: '点击“+”'
    },
    minus: {
      key: 'edit_minus',
      name: '点击“-”'
    },
    materialClick: {
      key: 'edit_materialClick',
      name: '点击“素材”'
    },
    materialDrag: {
      key: 'edit_materialDrag',
      name: '拖拽“素材”'
    },
    colorClick: {
      key: 'edit_colorClick',
      name: '点击“背景颜色”'
    },
    bgClick: {
      key: 'edit_bgClick',
      name: '点击“背景图片”'
    },
    materialSearch: {
      key: 'edit_materialSearch',
      name: '搜索素材'
    },
    uploadLocalMaterial: {
      key: 'edit_uploadLocalMaterial',
      name: '使用本地素材'
    },
    uploadURLMaterial: {
      key: 'edit_uploadUrl',
      name: '网址上传素材'
    },
    editMaterial: {
      key: 'edit_materialEdit',
      name: '素材裁剪'
    }
  },
  editorExport: {
    name: {
      key: 'export_name',
      name: '编辑页-导出'
    },
    editorName: {
      key: 'export_editorName',
      name: '编辑名称'
    },
    selectOtherTemplate: {
      key: 'export_selectOtherTemplate',
      name: '选择“其它尺寸模板”'
    },
    preview: {
      key: 'export_preview',
      name: '点击“预览”'
    },
    export: {
      key: 'export_export',
      name: '点击“确定导出”'
    },
    exportTest: {
      key: 'edit_exportTest',
      name: '点击“导出”(试用)'
    },
    save: {
      key: 'export_save',
      name: '点击“保存并关闭”'
    },
    switch: {
      key: 'export_switch',
      name: '点击左右切换查看'
    },
    exportType: {
      key: 'export_exportType',
      name: '点击展开"导出格式"'
    }
  },
  ps: {
    name: {
      key: 'ps',
      name: '智能抠图'
    }
  },
  ai: {
    name: {
      key: 'ai',
      name: 'AI作图'
    }
  },
  page: {
    enter: {
      key: 'enter_page',
      name: '进入页面'
    },
    leave: {
      key: 'leave_page',
      name: '离开页面'
    }
  },
  cutout: {
    pageKey: 'cutout', // 该值由ai那边提供
    time_to_export: {
      actionKey: 'cutout_uploadToExport',
      actionName: '点击上传图片到导出的时长'
    },
    time_to_save: {
      actionKey: 'cutout_uploadToSave',
      actionName: '点击上传图片到保存到素材库的时长'
    },
    time_to_matting: {
      actionKey: 'cutout_uploadToPage',
      actionName: '点击上传图片到进入到抠图页面时长'
    },
    upload_image: {
      actionKey: 'cutout_uploadPic',
      actionName: '点击“上传图片”'
    },
    keep: {
      actionKey: 'cutout_keep',
      actionName: '点击“保留”'
    },
    drop: {
      actionKey: 'cutout_remove',
      actionName: '点击“去除”'
    },
    erase: {
      actionKey: 'cutout_eraser',
      actionName: '点击“橡皮”'
    },
    change_width: {
      actionKey: 'cutout_strokeWidth',
      actionName: '拖拽“笔触宽度”'
    },
    change_feather: {
      actionKey: 'cutout_feathering',
      actionName: '拖拽“图片边缘羽化”'
    },
    change_preview: {
      actionKey: 'cutout_switchPreview',
      actionName: '勾选“切换预览背景图”'
    },
    next_step: {
      actionKey: 'cutout_next',
      actionName: '点击“下一步”'
    },
    enter_click: {
      actionKey: 'cutout_cut',
      actionName: '点击“素材裁剪”'
    },
    select_recommand: {
      actionKey: 'cutout_recommendedSize',
      actionName: '点击“选择推荐尺寸”'
    },
    select_option_one: {
      actionKey: 'cutout_300x300',
      actionName: '点击“300*300”'
    },
    select_option_two: {
      actionKey: 'cutout_600x600',
      actionName: '点击“600*600”'
    },
    select_option_three: {
      actionKey: 'cutout_800x800',
      actionName: '点击“800*800”'
    },
    input_width: {
      actionKey: 'cutout_width',
      actionName: '输入宽度'
    },
    input_height: {
      actionKey: 'cutout_height',
      actionName: '输入高度'
    },
    finish: {
      actionKey: 'cutout_finish',
      actionName: '点击“完成”'
    },
    undo: {
      actionKey: 'cutout_cancel',
      actionName: '点击“撤销”'
    },
    redo: {
      actionKey: 'cutout_resume',
      actionName: '点击“恢复”'
    },
    reset: {
      actionKey: 'cutout_clear',
      actionName: '点击“清除”'
    },
    upload: {
      actionKey: 'cutout_upload',
      actionName: '点击“上传”'
    },
    save: {
      actionKey: 'cutout_save',
      actionName: '点击“保存到素材库”'
    },
    export: {
      actionKey: 'cutout_export',
      actionName: '点击“导出”'
    },
    time_to_batch_export: {
      actionKey: 'cutout_batch_uploadToExport',
      actionName: '点击上传多张图片到导出的时长'
    },
    time_to_batch_save: {
      actionKey: 'cutout_batch_uploadToSave',
      actionName: '点击上传多张图片到保存到素材库的时长'
    },
    time_to_batch_matting: {
      actionKey: 'cutout_batch_uploadToPage',
      actionName: '点击多张上传图片到进入批量抠图页面时长'
    },
    upload_batch_images: {
      actionKey: 'cutout_batch_uploadPic',
      actionName: '点击“上传多张图片”'
    },
    restore_batch_images: {
      actionKey: 'cutout_batch_unSavedRecord',
      actionName: '点击“上一次保存抠图记录”'
    },
    submit_batch_images: {
      actionKey: 'cutout_batch_submitInPopup',
      actionName: '点击“提交并抠图”'
    },
    batch_forward: {
      actionKey: 'cutout_batch_immediatelyTo',
      actionName: '点击“立即前往”'
    },
    batch_upload: {
      actionKey: 'cutout_batch_upload',
      actionName: '点击“上传”'
    },
    batch_return: {
      actionKey: 'cutout_batch_back',
      actionName: '点击“返回”'
    },
    batch_edit: {
      actionKey: 'cutout_batch_edit',
      actionName: '点击“编辑”'
    },
    batch_watch: {
      actionKey: 'cutout_batch_view',
      actionName: '点击“查看”'
    },
    batch_select: {
      actionKey: 'cutout_batch_chose1Pic',
      actionName: '选中单张图片'
    },
    batch_save: {
      actionKey: 'cutout_batch_save',
      actionName: '点击“保存到素材库”'
    },
    batch_export: {
      actionKey: 'cutout_batch_export',
      actionName: '点击“导出”'
    },
    batch_save_return: {
      actionKey: 'cutout_batch_finishAndReturn',
      actionName: '点击“完成抠图并返回”'
    },
    batch_direct_return: {
      actionKey: 'cutout_batch_unSaveAndReturn',
      actionName: '点击“不保存，直接返回”'
    }
  },
  cloudClass: {
    name: {
      key: 'cloudClass',
      name: '云课堂跳转验证'
    }
  },
  dataView: {
    name: {
      key: 'dataView',
      name: '数据统计'
    }
  },
  fontFamily: {
    name: {
      key: 'fontFamily',
      name: '字体库'
    }
  },
  userManagement: {
    name: {
      key: 'userManagement',
      name: '成员管理'
    }
  },
  templateFree: {
    name: {
      key: 'edit',
      name: '自由模板编辑页'
    },
    rollback: {
      key: 'edit_rollback',
      name: '点击“撤销”'
    },
    rollnext: {
      key: 'edit_rollnext',
      name: '点击“前进”'
    },
    reset: {
      key: 'edit_reset',
      name: '点击“恢复”'
    },
    phoneView: {
      key: 'edit_preview',
      name: '点击“手机预览“'
    },
    save: {
      key: 'edit_save',
      name: '点击“保存作品”'
    },
    pngExport: {
      key: 'exportPNG',
      name: '点击“png"导出'
    },
    jpgExport: {
      key: 'exportJPG',
      name: '点击“png"导出'
    },
    pptExport: {
      key: 'exportPPT',
      name: '点击“ppt"导出'
    },
    multiImgExport: {
      key: 'exportSlice',
      name: '点击“导出多图“'
    },
    longImgExport: {
      key: 'exportLongPic',
      name: '点击“导出长图“'
    },
    layerSelect: {
      key: 'edit_selectLayer',
      name: '点击“选区“选中图层'
    },
    pageTab: {
      key: 'edit_templateTab',
      name: '点击“页面”tab标签'
    },
    textTab: {
      key: 'edit_selectWord',
      name: '点击“文字“tab标签'
    },
    imgTab: {
      key: 'edit_materialTab',
      name: '点击“素材“tab标签'
    },
    bgTab: {
      key: 'edit_bgTab',
      name: '点击“背景“tab标签'
    },
    tplStyleCopy: {
      key: 'edit_flushOtherTpl',
      name: '点击“同步更新其他模板”'
    },
    tplUpdate: {
      key: 'edit_updateTpl',
      name: '点击“更新模板”'
    },
    tplDownload: {
      key: 'template_download',
      name: '点击“下载“'
    },
    textAdd: {
      key: 'edit_addText',
      name: '点击“添加文字”'
    },
    projectImgAdd: {
      key: 'edit_clickProjectMaterial',
      name: '添加项目素材'
    },
    publicImgAdd: {
      key: 'edit_clickPublicMaterial',
      name: '添加公共素材'
    },
    projectImgNameSearch: {
      key: 'edit_materialSearch',
      name: '根据名称搜索项目素材'
    },
    projectImgMarkSearch: {
      key: 'edit_materialSearchByTag',
      name: '根据标签搜索项目素材'
    },
    publicImgNameSearch: {
      key: 'edit_publicMaterialSearch',
      name: '根据名称搜索公共素材'
    },
    publicImgMarkSearch: {
      key: 'edit_publicMaterialSearchByTag',
      name: '根据标签搜索公共素材'
    },
    localImgUpload: {
      key: 'edit_uploadLocalMaterial',
      name: '点击“上传本地素材”'
    },
    networkImgUpload: {
      key: 'edit_uploadUrl',
      name: '点击“输入网址并上传”'
    },
    projectBgAdd: {
      key: 'edit_bgClick',
      name: '替换项目背景素材'
    },
    publicBgAdd: {
      key: 'edit_publicBgClick',
      name: '替换公共背景素材'
    },
    oneAndOneScale: {
      key: 'edit_oneAndOne',
      name: '点击“1:1”'
    },
    minusScale: {
      key: 'edit_minus',
      name: '点击“-”'
    },
    plusScale: {
      key: 'edit_plus',
      name: '点击“+”'
    },
    defScale: {
      key: 'edit_reset',
      name: '点击“恢复默认”'
    },
    layerCopy: {
      key: 'edit_copyElement',
      name: '点击“复制&粘贴”'
    },
    layerDel: {
      key: 'edit_delLayer',
      name: '点击“删除图层”'
    },
    toTop: {
      key: 'edit_toTopLayer',
      name: '点击“置顶”'
    },
    toBottom: {
      key: 'edit_toLowestLayer',
      name: '点击“置底”'
    },
    toUp: {
      key: 'edit_upLayer',
      name: '点击“上移一层”'
    },
    toDown: {
      key: 'edit_downLayer',
      name: '点击“下移一层”'
    },
    sizeUpdate: {
      key: 'edit_changeDrawingSize',
      name: '修改画布尺寸'
    },
    cutImg: {
      key: 'editMulti_cutoutMaterial',
      name: '点击“裁剪图片”'
    },
    flipHorizon: {
      key: 'edit_flipHorizon',
      name: '点击“水平翻转”'
    },
    flipVertical: {
      key: 'edit_flipVertical',
      name: '点击“垂直翻转”'
    },
    imgOpacity: {
      key: 'edit_imgOpacity',
      name: '修改图片透明度'
    },
    imgColor: {
      key: 'edit_imgColor',
      name: '修改图片颜色'
    },
    bgColor: {
      key: 'edit_bgColorUpdate',
      name: '修改背景颜色'
    },
    bgUpload: {
      key: 'edit_bgUpload',
      name: '点击“上传背景”'
    },
    group: {
      key: 'edit_groupElement',
      name: '点击“分组”'
    },
    unGroup: {
      key: 'edit_cancelGroupElement',
      name: '点击“取消分组”'
    },
    fontFamily: {
      key: 'edit_changeFontFamily',
      name: '修改字体'
    },
    fontSize: {
      key: 'edit_changeFontSize',
      name: '修改字号'
    },
    textColor: {
      key: 'edit_changeTextColor',
      name: '修改文字颜色'
    },
    textStyle: {
      key: 'edit_changeTextStyle',
      name: '修改文字样式'
    },
    textOpacity: {
      key: 'edit_changeTextOpacity',
      name: '修改文字透明度'
    },
    textBold: {
      key: 'edit_changeTextBold',
      name: '点击“加粗”'
    },
    textUnderline: {
      key: 'edit_changeTextUnderline',
      name: '点击“下划线”'
    },
    texItalic: {
      key: 'edit_changeTextItalic',
      name: '点击“斜体”'
    },
    textLeft: {
      key: 'edit_changeTextLeft',
      name: '点击“左对齐”'
    },
    textCenter: {
      key: 'edit_changeTextCenter',
      name: '点击“居中”'
    },
    textRight: {
      key: 'edit_changeTextRight',
      name: '点击“右对齐”'
    },
    layerLock: {
      key: 'edit_lockLayer',
      name: '点击“锁定”'
    },
    layerUnLock: {
      key: 'edit_unlockLayer',
      name: '点击“取消锁定”'
    },
    layerMove: {
      key: 'edit_moveLayer',
      name: '移动图层'
    },
    layerResize: {
      key: 'edit_resizeLayer',
      name: '修改图层大小'
    },
    layerRotate: {
      key: 'edit_rotateLayer',
      name: '旋转图层'
    },
		layerHidden: {
			key: 'edit_hiddenLayer',
			name: '点击“隐藏”'
		},
		layerShow: {
			key: 'edit_showLayer',
			name: '点击“显示”'
		}
  },
  templateConfig: {
    name: {
      key: 'config',
      name: '配置页'
    }
  }
}

export class UserAction {
  constructor (
    projectId,
    startTime,
    endTime,
    pageKey,
    actionKey,
    userId,
    type,
    typeValue,
    groupName
  ) {
    this.projectId = projectId
    this.startTime = startTime
    this.endTime = endTime
    this.page = pageKey
    this.action = actionKey
    this.userId = userId
    this.templateType = type
    this.templateId = typeValue
    this.templateGroup = groupName
  }
}
